import React from 'react';
import { View } from 'react-native';
import { Icon } from 'react-native-elements';
import Colors from '../../../constants/Colorsv2';
import { Text } from '../../../globalComponents/NativeOverrides';
import { MetricsComponent } from '../../../objectTypes';


type MetricCardProps = { metric:MetricsComponent, market_type:string, show_filter:boolean }
const MetricCard = ({ metric, market_type }:MetricCardProps) => {
    const num = metric.metric_type === 'percent' ? metric.metric_number??0 * 100 : metric.metric_number??0
    const cl = market_type === 'FOR_MONEY' ? '$' : 'E'
    if(metric.full_width){
        return (
            <View style={{ flex:1, flexDirection:'row', padding:5, borderRadius:20, alignItems:'center', justifyContent:'space-between' }}>
                <View>
                    <Text size={14} weight='regular' color={Colors.brand.slate}>{metric.metric_name}</Text>
                </View>
                <View style={{flexDirection:'row', alignItems:'center', padding:5}}>
                    {metric.metric_type === 'dollar' ?
                    <Text size={16} weight='semibold' color={Colors.brand.midnight}>{cl}</Text>
                    :<></>}
                    <Text size={16} weight='semibold' color={Colors.brand.midnight}>{num.toFixed(2)}</Text>
                    {metric.metric_type === 'percent' ?
                    <Text size={16} weight='semibold' color={Colors.brand.midnight}>%</Text>
                    :<></>}
                </View>
            </View>
        )
    }

    return (
        <View style={{ flex:1, padding:16, borderRadius:20, alignItems:'flex-start' }}>
            <View style={{flexDirection:'row', alignItems:'center'}}>
                <Text size={14} weight='regular' color={Colors.brand.slate}>{metric.metric_name}</Text>
            </View>
            <View style={{flexDirection:'row', alignItems:'center', marginTop:8}}>
                {metric.metric_type === 'dollar' ?
                <Text size={26} weight='semibold' color={Colors.brand.midnight}>{cl}</Text>
                :<></>}
                <Text size={26} weight='semibold' color={Colors.brand.midnight}>{num.toFixed(2)}</Text>
                {metric.metric_type === 'percent' ?
                <Text size={26} weight='semibold' color={Colors.brand.midnight}>%</Text>
                :<></>}
            </View>
        </View>
    )
}

export default MetricCard